/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, Input, Optional, TrackByFunction} from '@angular/core';

import {Items} from './providers/items';
export class DatagridItemsTrackBy {
/**
 * @param {?} _items
 */
constructor(
private _items: Items) {}
/**
 * @param {?} value
 * @return {?}
 */
set trackBy(value: TrackByFunction<Function>) {
        if (this._items) {
            this._items.trackBy = value;
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: "[ngForTrackBy]",
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Items, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'trackBy': [{ type: Input, args: ["ngForTrackBy", ] },],
};
}

function DatagridItemsTrackBy_tsickle_Closure_declarations() {
/** @type {?} */
DatagridItemsTrackBy.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridItemsTrackBy.ctorParameters;
/** @type {?} */
DatagridItemsTrackBy.propDecorators;
/** @type {?} */
DatagridItemsTrackBy.prototype._items;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
